// extracted by mini-css-extract-plugin
export var bodySections = "_ed-8";
export var gray = "_ed-7";
export var green = "_ed-4";
export var iconContainer = "_ed-9";
export var iconWidgetContainer = "_ed-1";
export var phoneIcon = "_ed-2";
export var red = "_ed-5";
export var statusDot = "_ed-3";
export var widgetContainer = "_ed-0";
export var yellow = "_ed-6";